export class AuditingModel {
  RegionId: number;
  EngagementId: number;
  FunctionalityName: string;
  CreatedBy: number;
  TypeOfDatabook: string;
  mappingLevel: string;
}
